var _defs, _text, _polygon, _text2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuideMaterial5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 567.18 320.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:8px;font-family:ProximaNova-Light, Proxima Nova;font-weight:300;}.cls-1,.cls-17,.cls-3{fill:#231f20;}.cls-2{fill:url(#linear-gradient);}.cls-3{font-size:7.87px;font-family:ProximaNova-Bold, Proxima Nova;font-weight:700;}.cls-4{letter-spacing:-0.01em;}.cls-5{letter-spacing:0em;}.cls-6{font-family:ProximaNova-Regular, Proxima Nova;font-weight:400;}.cls-7{letter-spacing:-0.02em;}.cls-8{letter-spacing:-0.03em;}.cls-9{letter-spacing:-0.02em;}.cls-10{letter-spacing:-0.01em;}.cls-11{letter-spacing:-0.01em;}.cls-12{letter-spacing:-0.05em;}.cls-13{letter-spacing:-0.04em;}.cls-14{letter-spacing:-0.01em;}.cls-15{fill:#812990;}.cls-16{fill:#6b7b84;}.cls-18,.cls-19{fill:none;stroke-miterlimit:10;stroke-width:0.25px;}.cls-18{stroke:#ffcb05;}.cls-19{stroke:#6b7b84;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 466.61,
    y1: 259.46,
    x2: 567.05,
    y2: 259.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d60f84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#812990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(0.12 317.96)"
  }, "Size: 8inches x 4.25inches")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "567.05 301.31 516.83 217.61 466.61 301.31 567.05 301.31"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(195.43 234.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4"
  }, "K", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 4.9,
    y: 0
  }, "angaroo Education Foundation Education &amp; Visa Services")), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 9.45
  }, "Suite 1001, "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 38.34,
    y: 9.45
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    x: 42.05,
    y: 9.45
  }, "evel 1"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 61.26,
    y: 9.45
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 65.83,
    y: 9.45
  }, ", 307 Pitt "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 98.05,
    y: 9.45
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 102.53,
    y: 9.45
  }, "treet"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 0,
    y: 18.9
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 4.57,
    y: 18.9
  }, "ydney NSW 200"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 61.08,
    y: 18.9
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 65.65,
    y: 18.9
  }, ", "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 69.5,
    y: 18.9
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 74.59,
    y: 18.9
  }, "ustralia"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 0,
    y: 28.35
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 4.09,
    y: 28.35
  }, ": +61-2-80605365"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 37.8
  }, "ww"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 11.56,
    y: 37.8
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.99,
    y: 37.8
  }, ".kangarooedu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 64.95,
    y: 37.8
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 66.72,
    y: 37.8
  }, "com")))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M69.28,269.53l-1.13.16a3.83,3.83,0,0,1-.56.13c-.44,0-.66-.55-1.27-.67-.15,0,0,0-.22-.08s.07,0-.29-.13c0,.39-.09.28-.09.59a2.3,2.3,0,0,0,.25,1c.11.22.16.15.15.47a2.06,2.06,0,0,0,.18,1.29,3.19,3.19,0,0,1,.44.91c.6,0,.51,0,.59.18.56,0,.2-.13.51-.18,0,0,.57.14.42-.58.42.11.22.34.5.31s.11-.21.14-.47-.11-.07.29-.26l-.09-.51c0-.59.14,0,.34.09l.25-1.78c0-.14.18-.08-.16-.58C69.14,269.5,69.36,269.51,69.28,269.53Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M69.44,268c-.06.24.14.14-.16.16l.33.76c.15-.08.1-.06.34-.08,0-.52,0-.33-.18-.59S69.66,268.07,69.44,268Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M65.22,267.34c-.09.35,0,0-.12.27s-.15.76.36.49C65.46,267.5,65.53,267.55,65.22,267.34Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M58.71,261.36a3.05,3.05,0,0,0-1,.16c-.63.16-.35.3-.15.6a3.79,3.79,0,0,0,1.46-.21c.28-.05.3,0,.14-.3h-.42Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M75.81,257.22c0-.1,0-.19-.08-.29l-1-.36c-.69-.25-1.38-.51-2-.77s-1.38-.57-2.15-1-1.65-.83-2.5-1.36a5.68,5.68,0,0,1-2-2.32,7.7,7.7,0,0,1-.46-1.17h-.16a4.63,4.63,0,0,0-.93.12l-.87.22a10.85,10.85,0,0,1-2.36.45l-.31,0c-.3,0-.59,0-.89,0s-.46,0-.67,0a11.94,11.94,0,0,1-1.42-.26l-.49-.1-.38.45a1.42,1.42,0,0,1,.25.24,1.71,1.71,0,0,1,.36,1.66,2.56,2.56,0,0,1-2.21,1.62l-.8,0h-.14a2.68,2.68,0,0,1-2.17-1.42,1.89,1.89,0,0,1,.16-2.11l0-.07c.11-.18.23-.35.35-.52a7,7,0,0,0,.4-.62l.21-.45a2.89,2.89,0,0,1-2.43-1.84,5.72,5.72,0,0,1-.37-1.76l-.25.06-.39.1a4.63,4.63,0,0,1-.33.37,2.13,2.13,0,0,1-1.5.7,2.08,2.08,0,0,1-.6-.09h-.09a1.89,1.89,0,0,1-1.12-.35,1.5,1.5,0,0,1-.64-.44,1.48,1.48,0,0,1-.28-1.26,5.39,5.39,0,0,1,1-2.09,1.1,1.1,0,0,0,.12-.16,2,2,0,0,1,.59-1.2c.25-.25.51-.47.76-.69l.21-.17c.12-.1.26-.22.42-.33a2.66,2.66,0,0,1,.41-1.13,4.6,4.6,0,0,1,1.39-1.35c.29-.19.58-.35.86-.5l.43-.24.39-.24.22-.14a1.27,1.27,0,0,1,.68-.19,1.29,1.29,0,0,1,.54.12,1.32,1.32,0,0,1,.73,1.52s-.32,1.12-.43,1.48a3.31,3.31,0,0,1-.62,1.17c.27.17.59.38.91.62a5.26,5.26,0,0,1,.72.68h.55l.19,0a4.76,4.76,0,0,0,1.34-.61l.19-.11a11.42,11.42,0,0,1,2.63-1.25,18,18,0,0,1,4.67-.66H65c.87,0,1.74.05,2.54.09a15.37,15.37,0,0,1,1.94.27,11.3,11.3,0,0,1,4.67,2,.88.88,0,0,0-.46-.65c-.25-.11-.12,0-.3-.15l0,0-.18-.15c-.3-.19-.25.05-.36-.41l-.11.06s0,0,0,0c-.19.05-.13-.34-.3-.55s.07.16-.36-.06c-.24-.11,0,0-.14-.1a.35.35,0,0,0-.17-.09l-.15,0c-.7-.29-.57-.4-.57-1.11-.6-.16-.24-.61-.2-1,.07-.62-.3-.69-.15-1.36-.83,0-.5-.83-.73-1.72l0-.82c0-.17,0,.08.1-.23l-.23-.11c-.79-.48-.63-.85-.87-1l-.58.19c-.17.12,0,.09-.26.15-.56-.52-.3-1.61-.48-2.3-.08-.3-.14-.71-.54-.81a1.35,1.35,0,0,1,.25-.51c-.2-.1-.3-.07-.5-.17a2.41,2.41,0,0,0-.26-1.35c-.16-.27,0-.3-.42-.33-.1.39-.06.16-.42.33a2.36,2.36,0,0,1-.31,1.3s0,0,0,.05l-.07.1a1.63,1.63,0,0,0-.35.83h.25c0,.38,0,.16-.19.4s-.1,0,0,.42-.3.47-.26.94c0,.31.14.21.13.5s-.09.25-.08.49c0,.63.26.47,0,1.07s-.19,1.24-.57,1.87a7.85,7.85,0,0,0-.44.92,1.22,1.22,0,0,1-1,.37,3.72,3.72,0,0,1-.85-.42c-.16-.09-.29-.14-.36-.3s0-.11-.1-.24c-.2-.42-.76-.39-1.16-.54s-.54-.71-1.51-1.1l-.51-.16a4.68,4.68,0,0,1-.4-.27l-.32-.36c-.1-.09-.28-.19-.4-.29l-.36-.22c-.34-.18-.29,0-.3-.47.19-.06.4-.41.56-.63s0,0,.1-.15l.07-.18s0,0,0,0,.12-.31.17-.42c-.35-.14,0,.06-.33-.09.13-.2.1-.09.17-.34.44-.21.32-.08.58,0,.51-.74.22-.27.33-.7s.35-.45.52-.72l-.31-.2c-.35-.18-.27.14-.27-.48a1.56,1.56,0,0,0-.69.51c-.08-.11-.08.17-.08-.25a1.28,1.28,0,0,1-.43.16c.25-.32.14,0,.26-.33a2,2,0,0,0-1.1.42c-.21-.15-.34-.14-.42-.42-.43,0-.12.06-.5.17a2.08,2.08,0,0,0-.68-.35v-.16c-.45,0-.75.29-1.13-.15,0,0-.19-.31-.23-.36-.31.09-.17.09-.42.25a.65.65,0,0,0-.37-.47c-.14-.09,0,0-.18-.06l-.47,0c-.06,0,.13,0-.25.07v.26c.33.08,0,0,.24.1l.06,0,.05,0c.25.11.27,0,.67,0a1.88,1.88,0,0,1,.16.77l-.62.21,0,0-.76.09c-.32,0-.21-.07-.33-.32a1.5,1.5,0,0,0-.22.11l-.22.12c-.24.19.13.08-.28.23a.83.83,0,0,1-.39,0c0,.23,0,.22-.18.49s0,.25-.41.28c0,.61.06.26.17.67l-.27.1c-.42.1-.23.1-.37.52s-.37.12-.54.9c.27.19.34.19.39.36a.67.67,0,0,1,0,.31c-.8-.06-.44,0-.74,0a3.05,3.05,0,0,0-1-.15c0,.62,0,.2-.17.36l0,0-.12.19c0-.58.12-.17.16-.67-.71-.19-.68-1-1.4-1.07s0-.18-.62-.19c-.15.31-.07.37-.34.58.09-.39.05-.12,0-.24-.31.07-.19.08-.42.24-.05-.38-.1-.32-.42-.16.06.25,0,.18.24.25a.94.94,0,0,0-.17.51l-.5-.42c-.22.43,0,.28-.32.52l-.11.06c-.11.06-.14.1-.25.17.12.46.22.09.09.42-.29,0-.31.13-.51.39l0,0s-.05.06-.06.08l-.14.12c-.12.11-.27.16-.31.42a.75.75,0,0,0,.21.48c-.18.23-.16.15-.17.51l-.37-.12c-.39-.09-.19.21-.3-.13h-.42c0,.57-.22.44-.09.68s.31.21.51.5c-.21.09-.08.06-.34,0,0,.45.1.15,0,.59-.26-.18-.12-.13-.42-.68s-.31-.18-.26-.75c-.35.1-.32.27-.5.51l-.41.43a1.41,1.41,0,0,0-.33.67c0,.24.15.38.15.83,0,0,0,0,0,0l.22,0c-.05.18,0,.1-.12.22l-.07.09a.54.54,0,0,1-.14.12l-.14.11,0,0-.1.07c-.21.18-.16.2-.26.42l0,.12c-.51,1.33-.82,1.33-2.33,1.9-.28.1,0,.06-.31.09s-.22-.2-.57,0-.06.19-.33.42c-.43.33-.49-.14-1.28.67a.74.74,0,0,1-.53.21c-.43,0-.11-.25-.67.12,0-.45.09-.16-.16-.26-.07.27-.06.22-.28.4-.51.38-.1-.12-.84.69l-.08.09-.26.32s-.05.07-.08.1c-.4.44-1.25.26-1.25,1.61h-.25a5.63,5.63,0,0,1-.09-.93,2,2,0,0,0-.59,1.51c.27.1.07-.14.22.21a1.18,1.18,0,0,1-.06,1,1.15,1.15,0,0,0-.16.46v.6c0,.2.07.14.27.37s.06.31.43.75l.05,0c.1.13.11.17.21.3.34.43.48.21.48,1.21h-.18a1.36,1.36,0,0,0-.93-1.1c0,.78.21.26.26.84-.2-.12-.09-.09-.33-.16,0,.44.07.15-.18.25.55.82,1.41,1.13,1.62,2.18.08.47.58.72.75,1.11.1.23,0,.05.14.28a3,3,0,0,0,.26.24,1.19,1.19,0,0,1,.29.74c.28,1.78,1.36,2.15,1.48,3.21v.64c-.06.37.05.3.14.68s0,.49-.13.78a1.8,1.8,0,0,1-.5-.08c0,.61,0,1.17.53,1.15s.95.87,2.12.67c.36-.06,1,0,1.29-.16s.37-.4.5-.53l0,0,.12-.14.07-.08.25-.15c.2,0,.51,0,.6-.3,0,0,0-.13,0-.16.13-.47.8-.46,1.23-.6l1-.14h.2c.31,0-.09-.05.22-.05l.13,0,0,0c.3.14-.22.08.31.12.08-.19.18-.29.71-.28.36,0,1,.26,1.26-.88a.72.72,0,0,1,.16-.43c.21-.25.35-.14.68-.33,1.34-.78.82-.92,2.35-.94a4.59,4.59,0,0,0,1.61-.5c1-.4.9-.68,2.44-.68a3.57,3.57,0,0,0,1-.14c.37-.06,1.12.54,1.4.72.49-.12.23-.35.82,0,.36.21.61.13,1,.23.11.26,0,0,0,.42.28-.06.28-.11.51,0-.07.19-.16.13-.21.31l.17.48c.22.19.38,0,.59.26s.13.36.45.75a1.43,1.43,0,0,1,.27.81h0s0,0,0,0h-.05l-.21.22c.51.05.38.37.84.48a.53.53,0,0,1,.17,0s0,0,.17.08l-.06-.34c-.06-.26,0-.33.5-.91.31-.4.89-.4,1.13-.83a2.24,2.24,0,0,1,.37-.64c.21-.22.06.09.19-.23.05,0,0,0,0,0s0,0,.08.1a1.82,1.82,0,0,1,.14.19c-.25,0-.22,0-.34.16.17.39.19.34,0,.57a2,2,0,0,0-.42,1.33c0,.49-.12.38-.59.38-.07.31-.13.24-.17.6a1.79,1.79,0,0,0,.59-.18c.36-.08.4.2.6-.24l.34-1,.16.26s0,0,0,.06l.06.11a.09.09,0,0,1,0,.05c.47,1-.31,1-.36,1.54a2.91,2.91,0,0,0,.84-.16s0,0,.05,0,0,0,0,0c.52.45,1.08,1,.85,1.8a.43.43,0,0,0,0,.05l0,.42c.06.25.24.37.36.53l.35.57c.26.28.64.16.94.49l.24.28c.25-.09.25-.19.51-.11l.18.07.08,0c.22.07.11,0,.32.1s.86.49.93.67c.47,0,1.38-1.2,1.61-.33.42,0,.43-.3.77-.34l-.07.12c-.11.24-.06-.15-.11.3l.4.36.12.13.26.1a.59.59,0,0,1,.15.34.4.4,0,0,0,.25-.59c1,0,1.28-1,2.34-.95.68,0,1.21.23,1.71-.17l.18-.23c.12-.3,0-.37,0-.63l.45-1.23a1.66,1.66,0,0,1,.9-1.09c.24-.21.06-.06.08-.22v-.06l0-.22a1.74,1.74,0,0,1,.46-.81c.5-.41.29-.69,1-1.5l.49-.27.06,0,.17-.13C76,258.38,75.92,257.8,75.81,257.22Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M38.62,237.57s0,0,0,0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M54.19,243a11,11,0,0,0-.85-.83,12.08,12.08,0,0,0-1.3-.85,2.64,2.64,0,0,0-.66-.25,1.1,1.1,0,0,0-.41,0,2.68,2.68,0,0,1,.7-.8A2.51,2.51,0,0,0,52.6,239c.14-.49.28-1,.43-1.47l-.05,0-.65.4c-.41.23-.84.45-1.23.7a3.35,3.35,0,0,0-1,1,1.46,1.46,0,0,0-.19,1c0,.25-.12.26-.12.26a1.7,1.7,0,0,0-.75.44c-.3.26-.62.52-.9.8a.75.75,0,0,0-.23.45,1.34,1.34,0,0,1-.35.76,4.11,4.11,0,0,0-.74,1.6c0,.2,0,.28.26.24a.62.62,0,0,0,.69.26s.07,0,.09,0c.44.22.64.18,1.05-.21a2.22,2.22,0,0,0,.28-.33,1.27,1.27,0,0,1,.85-.41,2.43,2.43,0,0,0,1-.42s.23-.19.34-.05a3,3,0,0,1,.41.54,2.46,2.46,0,0,1,.19.8,5.07,5.07,0,0,0,.3,1.54,1.66,1.66,0,0,0,1.93,1,3.16,3.16,0,0,1,1.67,0,2.08,2.08,0,0,1,.32.14l-.62-.06a.18.18,0,0,0-.21.13c-.29.7-.58,1.4-.92,2.07-.22.44-.54.82-.8,1.24-.16.26-.38.54-.2.84a1.5,1.5,0,0,0,1.17.83l.86,0a1.32,1.32,0,0,0,1-.74.47.47,0,0,0-.12-.47c-.09.22-.25.25-.44.27a.94.94,0,0,0-.28.12c0-.19.18-.18.34-.24l0-.36-.1.06a.41.41,0,0,1-.56.19l-.23-.08c-.25-.07-.3,0-.32.2,0,0,0,.1,0,.19a.52.52,0,0,1,0-.67c.31-.39.63-.78,1-1.14a13,13,0,0,0,2-2.64,1.47,1.47,0,0,0,.19-.49,1,1,0,0,0-.46-1,8.59,8.59,0,0,0-1.2-.71.82.82,0,0,1-.51-1l.1.32c.1.3.38.39.62.52s.78.38,1.15.59a1.17,1.17,0,0,1,.38,1.87c-.21.32-.41.65-.61,1-.07.12-.07.2.11.23.68.12,1.35.31,2,.39a10.23,10.23,0,0,0,1.66,0,17.57,17.57,0,0,0,3-.64,4.45,4.45,0,0,1,1.78-.1.25.25,0,0,0,.12,0c0-.32-.07-.63-.1-.95s-.05-.52-.08-.79a6.39,6.39,0,0,0-.62-2.57c-.08-.14-.18-.26-.28-.41a1.57,1.57,0,0,1,.59.52,3.1,3.1,0,0,1,.47,1.28c.15.77.25,1.56.38,2.33a8.32,8.32,0,0,0,.7,2.44,4.52,4.52,0,0,0,1.59,1.82c.77.47,1.57.89,2.39,1.29.67.33,1.36.63,2,.91.87.35,1.74.66,2.61,1l1.26.45a.77.77,0,0,1,.5.48l-.68-.35,0,.05c.07.25.16.49.21.73.13.66.25,1.31.36,2,.09.51.17,1,.24,1.54,0,.28,0,.57,0,.86a1.8,1.8,0,0,0,.4,1.18,3.2,3.2,0,0,0,.27.25,8.57,8.57,0,0,1,1.47,1.81,1.41,1.41,0,0,0,.51.46h.41s0-.09,0-.11a.5.5,0,0,1,0-.65,1.86,1.86,0,0,0,.19-.46c.06-.28-.13-.47-.27-.68s-.11-.13-.17-.2l-.34.45,0,0a.79.79,0,0,0,.12-.89,1.4,1.4,0,0,0-.57-.77,1.37,1.37,0,0,1-.65-1.14c-.1-.59-.15-1.19-.22-1.78a7.13,7.13,0,0,1-.07-1c0-.5.11-1,.14-1.5a1.11,1.11,0,0,0-.3-.81,7.29,7.29,0,0,0-1.38-1c-.87-.6-1.75-1.2-2.57-1.85a12.13,12.13,0,0,1-2.83-3.23,4.07,4.07,0,0,1-.48-1.45,2.49,2.49,0,0,1,.16-1.21,5.22,5.22,0,0,0,.29,2.11c.45-.12.86-.29.93-.79a2.75,2.75,0,0,0-.06-.9c0-.28.1-.44.38-.38a1.38,1.38,0,0,1,.87.67c.7,1,1.36,2.08,2,3.13.41.63.81,1.28,1.24,1.9.57.84,1.15,1.67,1.76,2.49a15.31,15.31,0,0,0,1.06,1.23c.34.36.69.7,1,1a13,13,0,0,0,2.27,1.72,13.35,13.35,0,0,0,3.24,1.42,22,22,0,0,0,2.41.52,10.54,10.54,0,0,0,2,.12A13.89,13.89,0,0,0,93,260.7a11.94,11.94,0,0,0,3.19-1.1c.5-.25,1-.57,1.43-.85,0,0,.07-.06.08-.09s0-.22,0-.33a1,1,0,0,0-.28,0l-.74.32a14.72,14.72,0,0,1-2.72,1,13.41,13.41,0,0,1-1.89.36,14.57,14.57,0,0,1-2.09,0,8.79,8.79,0,0,1-3.58-1,10.91,10.91,0,0,1-2.42-1.68c-.27-.25-.54-.5-.8-.77a17.71,17.71,0,0,1-1.91-2.32,34.32,34.32,0,0,1-2-3.33c-.46-.83-.9-1.67-1.35-2.49a24.3,24.3,0,0,0-2.2-3.45,15.16,15.16,0,0,0-1.73-1.85,10,10,0,0,0-4.8-2.32,13.21,13.21,0,0,0-1.77-.24c-1-.06-2-.11-3-.08a17.27,17.27,0,0,0-4.34.6,11.53,11.53,0,0,0-2.54,1.25,5.68,5.68,0,0,1-1.71.75,1.82,1.82,0,0,1-.46.06,8.7,8.7,0,0,0-1,0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M165,229.63h-.68v1.93H164v-1.93h-.68v-.4H165Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M167.53,229.23v2.33h-.4v-1.65l-.77,1.19-.76-1.19v1.65h-.4v-2.33h.43l.73,1.13.73-1.13Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M103.77,235.26V236a5.43,5.43,0,0,0-1.33-.71,4.75,4.75,0,0,0-1.71-.28,5.24,5.24,0,0,0-2,.38,4.86,4.86,0,0,0-3,4.56,4.89,4.89,0,0,0,1.41,3.48,5,5,0,0,0,1.59,1.06,5.24,5.24,0,0,0,2,.38h.2a5.42,5.42,0,0,0,2-.38v-2.66h0a2.88,2.88,0,0,1-.93.59,3,3,0,0,1-1.08.19,3.44,3.44,0,0,1-.46,0h0a2.86,2.86,0,0,1-.64-.16,2.6,2.6,0,0,1-.91-.59,2.51,2.51,0,0,1-.83-1.89,2.54,2.54,0,0,1,.83-1.91,2.88,2.88,0,0,1,.91-.58,3,3,0,0,1,1.1-.21,2.83,2.83,0,0,1,2,.79,2.54,2.54,0,0,1,.83,1.91v4.92h2.36v-9.62Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M93.76,244.88l-5.25-5.06v5.06H86.15V231.56h2.36v5l5.25-5h3.35l-6.92,6.63,6.92,6.67Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M112.28,235a4.15,4.15,0,0,1,1.75.35,3.84,3.84,0,0,1,1.35.95,4.63,4.63,0,0,1,.87,1.41,4.9,4.9,0,0,1,.3,1.72v5.43h-2.36v-5.43a2,2,0,0,0-.69-1.55,2.38,2.38,0,0,0-3.25,0,2.05,2.05,0,0,0-.67,1.55v5.43h-2.37v-9.6h2.37V236a4.73,4.73,0,0,1,1.2-.7A4,4,0,0,1,112.28,235Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M144.32,235.28a4.21,4.21,0,0,1,1.59-.28v2.25a2.82,2.82,0,0,0-2,.78,2.63,2.63,0,0,0-.83,1.91v4.94h-2.36v-9.62h2.36V236A5.64,5.64,0,0,1,144.32,235.28Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M151.26,235a5.47,5.47,0,0,1,2,.38,5.25,5.25,0,0,1,1.65,1.06,4.85,4.85,0,0,1,1.12,1.57,4.81,4.81,0,0,1,0,3.84,4.85,4.85,0,0,1-1.12,1.57,5.25,5.25,0,0,1-1.65,1.06,5.61,5.61,0,0,1-4.06,0,5.25,5.25,0,0,1-1.65-1.06,4.85,4.85,0,0,1-1.12-1.57,4.81,4.81,0,0,1,0-3.84,4.85,4.85,0,0,1,1.12-1.57,5.25,5.25,0,0,1,1.65-1.06A5.47,5.47,0,0,1,151.26,235Zm0,2.24a2.83,2.83,0,0,0-2,.79,2.54,2.54,0,0,0-.83,1.91,2.51,2.51,0,0,0,.83,1.89,2.55,2.55,0,0,0,.92.59,3,3,0,0,0,1.09.19,3,3,0,0,0,1.08-.19,2.88,2.88,0,0,0,.93-.59,2.51,2.51,0,0,0,.83-1.89,2.54,2.54,0,0,0-.83-1.91A2.93,2.93,0,0,0,151.26,237.26Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M162.32,235a5.3,5.3,0,0,1,3.69,1.44,5,5,0,0,1,1.11,1.57,4.7,4.7,0,0,1,0,3.84,5,5,0,0,1-1.11,1.57,5.3,5.3,0,0,1-3.69,1.44,5.47,5.47,0,0,1-2-.38,5.25,5.25,0,0,1-1.65-1.06,4.82,4.82,0,0,1-1.11-1.57,4.7,4.7,0,0,1,0-3.84,4.82,4.82,0,0,1,1.11-1.57,5.25,5.25,0,0,1,1.65-1.06A5.47,5.47,0,0,1,162.32,235Zm0,2.24a2.86,2.86,0,0,0-2,.79,2.53,2.53,0,0,0-.82,1.91,2.5,2.5,0,0,0,.82,1.89,2.64,2.64,0,0,0,.92.59,3.09,3.09,0,0,0,1.09.19,3,3,0,0,0,1.09-.19,2.73,2.73,0,0,0,.92-.59,2.51,2.51,0,0,0,.83-1.89,2.54,2.54,0,0,0-.83-1.91A2.91,2.91,0,0,0,162.32,237.26Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M137,235.26V236a5.19,5.19,0,0,0-1.32-.71A4.81,4.81,0,0,0,134,235a5.24,5.24,0,0,0-2,.38,4.89,4.89,0,0,0-2.63,2.63,5.17,5.17,0,0,0,0,3.84A4.89,4.89,0,0,0,132,244.5a5.24,5.24,0,0,0,2,.38h.2a5.42,5.42,0,0,0,2-.38v-2.66h0a2.88,2.88,0,0,1-.93.59,3,3,0,0,1-1.08.19,3.44,3.44,0,0,1-.46,0h0a2.65,2.65,0,0,1-.63-.16,2.55,2.55,0,0,1-.92-.59,2.51,2.51,0,0,1-.83-1.89,2.54,2.54,0,0,1,.83-1.91,2.82,2.82,0,0,1,.92-.58,2.86,2.86,0,0,1,1.09-.21,2.83,2.83,0,0,1,2,.79A2.54,2.54,0,0,1,137,240v4.92h2.36v-9.62Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M125.58,235.26V236a5.19,5.19,0,0,0-1.32-.71,4.51,4.51,0,0,0-.86-.22,6.49,6.49,0,0,0-1-.08,5,5,0,0,0-2,.38,4.61,4.61,0,0,0-1.53,1.06,4.84,4.84,0,0,0-1,1.57,5.34,5.34,0,0,0-.35,1.93h0a4.92,4.92,0,0,0,.37,1.91,4.89,4.89,0,0,0,2.63,2.63,5.24,5.24,0,0,0,2,.38h.35a5.11,5.11,0,0,0,1.87-.37v-2.66h0a2.88,2.88,0,0,1-.93.59,3,3,0,0,1-1.08.19,3.44,3.44,0,0,1-.46,0h0a2.65,2.65,0,0,1-.63-.16A2.74,2.74,0,0,1,119.9,240a2.47,2.47,0,0,1,.2-1l0-.08a2.79,2.79,0,0,1,.6-.83,2.82,2.82,0,0,1,.92-.58,2.86,2.86,0,0,1,1.09-.21,2.83,2.83,0,0,1,2,.79,2.79,2.79,0,0,1,.6.83l0,.08a2.51,2.51,0,0,1,.2,1v3.74a2.51,2.51,0,0,1-.83,1.89,2.88,2.88,0,0,1-3.43.43l-1.71,1.61a5,5,0,0,0,1.45.75,5.47,5.47,0,0,0,1.68.26,5.26,5.26,0,0,0,3.68-1.46,4.85,4.85,0,0,0,1.12-1.57,4.57,4.57,0,0,0,.4-1.91v-8.44Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M88.9,253v.63H86.15v-3.58h2.64v.63H86.86v.91h1.62v.61H86.86v.8Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M93.43,249.77v3.83h-.71v-.17a1.61,1.61,0,0,1-.8.21,1.43,1.43,0,0,1,0-2.85,1.64,1.64,0,0,1,.8.21v-1.23Zm-.71,3v-1.11a1.06,1.06,0,0,0-.67-.23.79.79,0,0,0-.83.79.78.78,0,0,0,.83.78A1.06,1.06,0,0,0,92.72,252.77Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M97.94,250.85v2.75h-.7v-.18a1.36,1.36,0,0,1-.76.22c-.8,0-1.17-.37-1.17-1.27v-1.52H96v1.52c0,.43.21.64.6.64a1,1,0,0,0,.63-.22v-1.94Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M102.29,253.09a1.33,1.33,0,0,1-1.07.55,1.42,1.42,0,1,1,0-2.84,1.35,1.35,0,0,1,1.08.54l-.46.43a.73.73,0,0,0-.62-.34.79.79,0,1,0,0,1.58.73.73,0,0,0,.62-.34Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M106.81,250.85v2.75h-.7v-.2a1.48,1.48,0,0,1-.81.24,1.43,1.43,0,0,1,0-2.85,1.62,1.62,0,0,1,.81.23v-.17Zm-.7.82a1.06,1.06,0,0,0-.68-.24.79.79,0,1,0,0,1.58,1.09,1.09,0,0,0,.68-.23Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M109.58,251.43v1c0,.49.08.63.44.63a2.69,2.69,0,0,0,.32,0v.53a1.73,1.73,0,0,1-.64.1.78.78,0,0,1-.83-.86v-1.35h-.39v-.58h.39v-1.07h.71v1.07h.77v.58Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M112,250.18a.41.41,0,1,1,.4.41A.41.41,0,0,1,112,250.18Zm0,.71h.71v2.75h-.71Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M117.6,252.22a1.51,1.51,0,1,1-1.5-1.42A1.46,1.46,0,0,1,117.6,252.22Zm-.69,0a.8.8,0,0,0-.81-.79.79.79,0,1,0,0,1.58A.8.8,0,0,0,116.91,252.22Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M122,252.11v1.53h-.7v-1.53c0-.43-.21-.64-.6-.64a.88.88,0,0,0-.61.22v1.95h-.71v-2.75h.71v.17a1.26,1.26,0,0,1,.73-.22C121.63,250.84,122,251.21,122,252.11Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M127.54,250.69V252h1.71v.63h-1.71v1h-.7v-3.58h2.69v.63Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M134.09,252.22a1.51,1.51,0,1,1-1.51-1.42A1.46,1.46,0,0,1,134.09,252.22Zm-.69,0a.82.82,0,1,0-.82.79A.8.8,0,0,0,133.4,252.22Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M138.47,250.85v2.75h-.7v-.18a1.35,1.35,0,0,1-.75.22c-.81,0-1.18-.37-1.18-1.27v-1.52h.7v1.52c0,.43.21.64.6.64a.93.93,0,0,0,.63-.22v-1.94Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M143,252.11v1.53h-.7v-1.53c0-.43-.21-.64-.6-.64a.89.89,0,0,0-.61.22v1.95h-.71v-2.75h.71v.17a1.29,1.29,0,0,1,.74-.22C142.63,250.84,143,251.21,143,252.11Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M147.67,249.77v3.83H147v-.17a1.61,1.61,0,0,1-.8.21,1.43,1.43,0,0,1,0-2.85,1.59,1.59,0,0,1,.8.21v-1.23Zm-.72,3v-1.11a1,1,0,0,0-.67-.23.79.79,0,0,0-.82.79.77.77,0,0,0,.82.78A1,1,0,0,0,147,252.77Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M152.34,250.85v2.75h-.71v-.2a1.46,1.46,0,0,1-.81.24,1.43,1.43,0,0,1,0-2.85,1.59,1.59,0,0,1,.81.23v-.17Zm-.71.82a1,1,0,0,0-.68-.24.79.79,0,1,0,0,1.58,1.07,1.07,0,0,0,.68-.23Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M155.1,251.43v1c0,.49.09.63.44.63a3.11,3.11,0,0,0,.33,0v.53a1.79,1.79,0,0,1-.64.1.79.79,0,0,1-.84-.86v-1.35H154v-.58h.39v-1.07h.71v1.07h.78v.58Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M157.56,250.18a.42.42,0,0,1,.41-.42.42.42,0,0,1,0,.83A.42.42,0,0,1,157.56,250.18Zm.06.71h.7v2.75h-.7Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M163.13,252.22a1.51,1.51,0,1,1-1.51-1.42A1.47,1.47,0,0,1,163.13,252.22Zm-.7,0a.81.81,0,1,0-.81.79A.8.8,0,0,0,162.43,252.22Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M167.53,252.11v1.53h-.71v-1.53c0-.43-.21-.64-.6-.64a.89.89,0,0,0-.61.22v1.95h-.7v-2.75h.7v.17a1.29,1.29,0,0,1,.74-.22C167.15,250.84,167.53,251.21,167.53,252.11Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M102.83,259.94v.63h-2.76V257h2.65v.63h-1.94v.92h1.62v.61h-1.62v.8Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M106.1,256.73v3.84h-.71v-.16a1.68,1.68,0,0,1-.81.21,1.43,1.43,0,0,1,0-2.86,1.65,1.65,0,0,1,.81.21v-1.24Zm-.71,3v-1.11a1.08,1.08,0,0,0-.68-.24.79.79,0,0,0-.82.8.77.77,0,0,0,.82.79A1,1,0,0,0,105.39,259.74Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M109.35,257.81v2.76h-.7v-.18a1.36,1.36,0,0,1-.76.22c-.81,0-1.18-.37-1.18-1.27v-1.53h.71v1.53c0,.43.21.64.6.64a1,1,0,0,0,.63-.22v-1.95Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M112.44,260.06a1.33,1.33,0,0,1-1.07.55,1.43,1.43,0,1,1,0-2.85,1.32,1.32,0,0,1,1.08.55l-.46.42a.75.75,0,0,0-.62-.34.8.8,0,1,0,0,1.59.72.72,0,0,0,.62-.34Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M115.71,257.81v2.76H115v-.2a1.46,1.46,0,0,1-.81.24,1.43,1.43,0,0,1,0-2.86,1.59,1.59,0,0,1,.81.23v-.17Zm-.71.82a1.1,1.1,0,0,0-.68-.24.79.79,0,0,0-.82.79.79.79,0,0,0,.82.8,1,1,0,0,0,.68-.24Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M117.21,258.39v1c0,.5.08.64.44.64a3.11,3.11,0,0,0,.33,0v.53a1.82,1.82,0,0,1-.65.1.79.79,0,0,1-.83-.87v-1.35h-.39v-.58h.39v-1.08h.71v1.08H118v.58Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M118.41,257.09a.41.41,0,1,1,.81,0,.41.41,0,1,1-.81,0Zm0,.72h.71v2.76h-.71Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M122.72,259.19a1.52,1.52,0,1,1-1.52-1.43A1.47,1.47,0,0,1,122.72,259.19Zm-.7,0a.82.82,0,1,0-.82.79A.81.81,0,0,0,122,259.19Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M125.85,259v1.54h-.7V259c0-.43-.21-.64-.6-.64a1,1,0,0,0-.62.22v2h-.7v-2.76h.7V258a1.32,1.32,0,0,1,.74-.22C125.48,257.76,125.85,258.13,125.85,259Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M131.2,259a6.13,6.13,0,0,1-.55.82l.43.42-.42.39-.4-.39a1.51,1.51,0,0,1-.95.39c-.83,0-1.36-.38-1.36-1a1.07,1.07,0,0,1,.75-1,1,1,0,0,1-.31-.7,1,1,0,0,1,2-.07,1.1,1.1,0,0,1-.77,1l.61.59a5,5,0,0,0,.43-.59Zm-1.31.84-.8-.78c-.29.12-.43.3-.43.5s.24.5.68.5A.83.83,0,0,0,129.89,259.82Zm-.91-1.89a.72.72,0,0,0,.32.52c.22-.07.53-.23.53-.52a.43.43,0,0,0-.43-.47A.44.44,0,0,0,129,257.93Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M135.94,257h.79l-1.67,3.59h-.34L133.05,257h.79l1,2.35Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M137.05,257.09a.42.42,0,0,1,.41-.41.42.42,0,0,1,0,.83A.42.42,0,0,1,137.05,257.09Zm.06.72h.71v2.76h-.71Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M138.59,259.82a2.18,2.18,0,0,0,.95.23c.32,0,.45-.12.45-.27s-.16-.23-.58-.32c-.6-.13-1-.32-1-.86s.41-.84,1.05-.84a2.83,2.83,0,0,1,1.08.22l-.23.52a2.65,2.65,0,0,0-.86-.18c-.27,0-.41.1-.41.25s.17.22.61.31c.64.13,1,.36,1,.86s-.4.87-1.11.87a2.37,2.37,0,0,1-1.19-.26Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M143.91,257.81v2.76h-.71v-.2a1.46,1.46,0,0,1-.81.24,1.43,1.43,0,0,1,0-2.86,1.59,1.59,0,0,1,.81.23v-.17Zm-.71.82a1.1,1.1,0,0,0-.68-.24.8.8,0,1,0,0,1.59,1,1,0,0,0,.68-.24Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M149,259.52c0,.69-.56,1.1-1.4,1.1a2.81,2.81,0,0,1-1.49-.34l.27-.57a2.52,2.52,0,0,0,1.25.28c.39,0,.63-.14.63-.41s-.24-.35-.77-.47c-.74-.17-1.33-.38-1.33-1.09s.5-1.08,1.32-1.08a3.54,3.54,0,0,1,1.38.29l-.3.58a3.19,3.19,0,0,0-1.09-.24c-.37,0-.57.17-.57.39s.25.36.79.48C148.43,258.62,149,258.86,149,259.52Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M150.06,259.39a.76.76,0,0,0,.79.62.87.87,0,0,0,.71-.34l.45.37a1.51,1.51,0,0,1-1.25.57,1.43,1.43,0,0,1,0-2.85,1.32,1.32,0,0,1,1.35,1.47c0,.06,0,.12,0,.16Zm0-.45h1.37a.61.61,0,0,0-.67-.62A.73.73,0,0,0,150.06,258.94Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M153.33,258.19a1,1,0,0,1,.87-.43.51.51,0,0,1,.17,0v.77a2,2,0,0,0-.34,0,.66.66,0,0,0-.7.72v1.33h-.72v-2.76h.72Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M157.59,257.81l-1.33,2.76h-.33l-1.33-2.76h.74l.76,1.57.74-1.57Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M158,257.09a.41.41,0,1,1,.41.42A.41.41,0,0,1,158,257.09Zm.06.72h.7v2.76H158Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M161.82,260.06a1.33,1.33,0,0,1-1.07.55,1.43,1.43,0,1,1,0-2.85,1.32,1.32,0,0,1,1.08.55l-.46.42a.75.75,0,0,0-.62-.34.8.8,0,1,0,0,1.59.72.72,0,0,0,.62-.34Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M162.81,259.39a.77.77,0,0,0,.79.62.87.87,0,0,0,.71-.34l.46.37a1.52,1.52,0,0,1-1.25.57,1.43,1.43,0,0,1,0-2.85,1.32,1.32,0,0,1,1.34,1.47v.16Zm0-.45h1.37a.62.62,0,0,0-.67-.62A.72.72,0,0,0,162.82,258.94Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M165.48,259.82a2.18,2.18,0,0,0,1,.23c.33,0,.45-.12.45-.27s-.15-.23-.58-.32c-.6-.13-1-.32-1-.86s.41-.84,1-.84a2.79,2.79,0,0,1,1.08.22l-.23.52a2.65,2.65,0,0,0-.86-.18c-.27,0-.41.1-.41.25s.17.22.61.31c.64.13,1,.36,1,.86s-.41.87-1.11.87a2.43,2.43,0,0,1-1.2-.26Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 301.31,
    x2: 567.05,
    y2: 301.31
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 0.13,
    x2: 0.13,
    y2: 301.31
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 558.13,
    y1: 0.13,
    x2: 558.13,
    y2: 301.31
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 55.93,
    y1: 0.13,
    x2: 55.93,
    y2: 301.31
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 111.73,
    y1: 0.13,
    x2: 111.73,
    y2: 301.31
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 167.53,
    y1: 0.13,
    x2: 167.53,
    y2: 301.31
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 223.33,
    y1: 0.13,
    x2: 223.33,
    y2: 301.31
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 279.13,
    y1: 0.13,
    x2: 279.13,
    y2: 301.31
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 334.93,
    y1: 0.13,
    x2: 334.93,
    y2: 301.31
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 390.73,
    y1: 0.13,
    x2: 390.73,
    y2: 301.31
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 446.53,
    y1: 0.13,
    x2: 446.53,
    y2: 301.31
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 502.33,
    y1: 0.13,
    x2: 502.33,
    y2: 301.31
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 28.03,
    y1: 0.13,
    x2: 28.03,
    y2: 301.31
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 83.83,
    y1: 0.13,
    x2: 83.83,
    y2: 301.31
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 139.63,
    y1: 0.13,
    x2: 139.63,
    y2: 301.31
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 195.43,
    y1: 0.13,
    x2: 195.43,
    y2: 301.31
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 251.23,
    y1: 0.13,
    x2: 251.23,
    y2: 301.31
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 307.03,
    y1: 0.13,
    x2: 307.03,
    y2: 301.31
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 362.83,
    y1: 0.13,
    x2: 362.83,
    y2: 301.31
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 418.63,
    y1: 0.13,
    x2: 418.63,
    y2: 301.31
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 474.43,
    y1: 0.13,
    x2: 474.43,
    y2: 301.31
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 530.23,
    y1: 0.13,
    x2: 530.23,
    y2: 301.31
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 245.51,
    x2: 567.05,
    y2: 245.51
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 189.71,
    x2: 567.05,
    y2: 189.71
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 133.91,
    x2: 567.05,
    y2: 133.91
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 78.11,
    x2: 567.05,
    y2: 78.11
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 22.31,
    x2: 567.05,
    y2: 22.31
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 273.41,
    x2: 567.05,
    y2: 273.41
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 217.61,
    x2: 567.05,
    y2: 217.61
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 161.81,
    x2: 567.05,
    y2: 161.81
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 106.01,
    x2: 567.05,
    y2: 106.01
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 50.21,
    x2: 567.05,
    y2: 50.21
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 0.13,
    y: 0.13,
    width: 566.93,
    height: 301.18
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideMaterial5);
export default __webpack_public_path__ + "static/media/guideMaterial5.93ec6af99ba3a2fad1103e1c72f9557f.svg";
export { ForwardRef as ReactComponent };